import type { PuzzleDefinition, LevelData, Difficulty, Category } from '../types';

export interface LevelJSON {
  id: string;
  name: string;
  category: Category;
  solution: string[];
  puzzles: {
    id: string;
    row: number;
    col: number;
    width: number;
    height: number;
    difficultyScore?: number;
  }[];
  difficultyScore?: number;
  // Extra source fields (ignored at runtime)
  source?: unknown;
  fillRatio?: number;
}

function parseSolution(rows: string[]): boolean[][] {
  return rows.map((row) => [...row].map((c) => c === '1'));
}

export function parseLevelJSON(json: LevelJSON, fallbackId?: string): LevelData {
  return {
    id: json.id ?? fallbackId ?? '',
    name: json.name,
    category: json.category,
    solution: parseSolution(json.solution),
    puzzles: json.puzzles.map((p): PuzzleDefinition => ({
      id: p.id,
      row: p.row,
      col: p.col,
      width: p.width,
      height: p.height,
      difficulty: p.difficultyScore ?? 0,
    })),
  };
}
